import script from "./Marketing.vue?vue&type=script&setup=true&lang=js"
export * from "./Marketing.vue?vue&type=script&setup=true&lang=js"

import "./Marketing.vue?vue&type=style&index=0&id=0e806874&lang=scss"

const __exports__ = script;

export default __exports__